import { render, staticRenderFns } from "./CoRoundButton.vue?vue&type=template&id=45d9b7de&scoped=true&"
import script from "./CoRoundButton.vue?vue&type=script&lang=ts&"
export * from "./CoRoundButton.vue?vue&type=script&lang=ts&"
import style0 from "./CoRoundButton.vue?vue&type=style&index=0&id=45d9b7de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d9b7de",
  null
  
)

export default component.exports